import React, { useState, useEffect, useRef  } from "react";
import { createPortal } from "react-dom";
import api from "../../services/api";
import YouTube from "react-youtube";
import Plyr from "plyr";
import "./training-improvements.css";
//import logo from "../../assets/logo3.png";

/** Lista URLs nomeadas: arquivosMaterial + link legado materialApoio (sem duplicar URL). */
function buildMateriaisApoio(doc) {
  const out = [];
  if (!doc) return out;
  if (Array.isArray(doc.arquivosMaterial)) {
    doc.arquivosMaterial.forEach((a) => {
      if (a && typeof a.url === "string" && a.url.trim()) {
        out.push({
          url: a.url.trim(),
          nome: (a.nome && String(a.nome).trim()) || "Arquivo",
        });
      }
    });
  }
  const legado = doc.materialApoio && String(doc.materialApoio).trim();
  if (legado && !out.some((x) => x.url === legado)) {
    out.push({ url: legado, nome: "Material de apoio" });
  }
  return out;
}

export default function Treinamento({ history }) {
  const [video, setVideo] = useState("");
  const [videoToken, setVideoToken] = useState("");
  const [videoUrl, setVideoUrl] = useState(null);
  const [produto, setProduto] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const [subEtapas, setSubEtapas] = useState([]);
  const [loading, setLoading] = useState("");
  const [currentTopic, setCurrentTopic] = useState("");
  const [currentSubTopic, setCurrentSubTopic] = useState("");
  const [currentTitle, setCurrentTitle] = useState("");
  const [videoStarted, setVideoStarted] = useState(false);
  const [todosVideosConcluidos, setTodosVideosConcluidos] = useState(false);
  const [carregandoVideo, setCarregandoVideo] = useState(false);
  const [materialModalOpen, setMaterialModalOpen] = useState(false);

  const url_string = window.location.href;
  const param = url_string.split("/");
  const empresanome = localStorage.getItem("sgiempresanome");
  const isMaster = String(localStorage.getItem("sgimaster")).toLowerCase() === "true";
  var videoControl = false;
  var playerRef = useRef(null);

  const checkValidUser = async () => {
    const userId = localStorage.getItem("sgiuserid");
    const response = await api.get("/treinamentos/usuarios/" + userId);
    const data = await response.data;
    if (typeof data[0] !== "object") {
      localStorage.clear();
      history.push("/login");
    }
  };

  async function loadProduto() {
    const query = "/treinamentos/produtocliente/" + param[4];
    const response = await api.get(query);
    const data = await response.data;
    setProduto(data);

    // aggregate no topico e subtopico
    const query2 = "/treinamentos/topicocliente/aggregate/produto/" + param[4];
    const response2 = await api.get(query2);
    const data2 = await response2.data;
    setEtapas(data2);

    if (videoControl == false) {
      for (var i = 0; i < data2.length; i++) {
        for (var j = 0; j < data2[i].subtopicos.length; j++) {
          const sub = data2[i].subtopicos[j];
          if (sub.status == 0 && !!sub.linkVideo) {
            setTodosVideosConcluidos(false);
            await setCurrentValues(
              sub.linkVideo,
              data2[i]._id,
              sub._id,
              sub.titulo
            );
            videoControl = true;
            return true;
          }
        }
      }
    }
    // Nenhum vídeo pendente (todos concluídos) - não definir primeiro vídeo de novo
    if (videoControl == false) {
      setTodosVideosConcluidos(true);
      return false;
    }
    return true;
  }

  async function onVideoEnd() {
    //update currentSubTopic com status 1     
    const dataobj = {
      status: 1,
      currentTreinamento: param[4]
    };

    await api.put("/treinamentos/subtopicocliente/" + currentSubTopic, dataobj);
    videoControl = false;
    const temProximoVideo = await loadProduto();
    setTimeout(() => {
      if (temProximoVideo) {
        alert(currentTitle + " foi finalizado. Siga para a próxima etapa");
      } else {
        alert("Parabéns! Você concluiu todos os vídeos deste treinamento.");
      }
    }, 1000);
  };

  // Função para obter URL do thumbnail do YouTube
  const getYouTubeThumbnail = (videoId) => {
    if (!videoId) return '';
    // Tenta maxresdefault primeiro (alta qualidade), se não existir, usa hqdefault
    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  };

  const opts = {
    height: "100%",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: videoStarted ? 1 : 0, // Autoplay quando vídeo for iniciado
      rel: 0,
      modestbranding: 1, // Reduz o branding do YouTube
      controls: 1, // Mostra controles
      showinfo: 0, // Não mostra informações do vídeo
      iv_load_policy: 3, // Desabilita anotações
      fs: 0, // Desabilita botão de tela cheia (opcional)
      disablekb: 0, // Mantém teclado habilitado
      playsinline: 1, // Reproduz inline em dispositivos móveis
      origin: window.location.origin, // Define origem para segurança
    }
  };

  // Função para iniciar o vídeo
  const handleStartVideo = () => {
    setVideoStarted(true);
  };

  useEffect(() => {
    setLoading(true);
    checkValidUser();
    loadProduto();
    document.body.style.backgroundColor = "#eefbf3";
  }, []);


  async function setCurrentValues(linkVideo, idtopico, idsubtopico, titulo) {
    if (!linkVideo) {
      setVideo("");
      setVideoUrl(null);
      setCarregandoVideo(false);
      return;
    }
    setCarregandoVideo(true);
    setTodosVideosConcluidos(false);
    setVideo(linkVideo);
    setCurrentTopic(idtopico);
    setCurrentSubTopic(idsubtopico);
    setCurrentTitle(titulo);
    setVideoStarted(false); // Reset video started quando mudar de vídeo
    setVideoUrl(null);
    
    // MP4 (link grande) precisa do token; YouTube (id curto) não.
    if (linkVideo.length <= 15) {
      setCarregandoVideo(false);
      return;
    }

    try {
      const query = "/videoToken/" + linkVideo;
      const videoLink = await api.get(query);
      setVideoUrl(videoLink.data);
    } catch (e) {
      setVideoUrl(null);
      // Mantém o fluxo sem quebrar a tela; o placeholder continuará visível
      // e o usuário pode escolher outro item na playlist.
    } finally {
      setCarregandoVideo(false);
    }
  }

  function gotoAvaliacao() {
    if (produto[0]?.progresso == 100) {
      history.push("/avaliacao/" + produto[0]._id)
    } else {
      alert("Finalize todas as etapas antes de realizar a avaliação")
    }
  }

  return (
    <div className="main-wrapper">
      {/* Login Header Start */}
      <div className="section login-header">
        {/* Login Header Wrapper Start */}
        <div className="login-header-wrapper navbar navbar-expand">
          {/* Header Logo Start */}
          <div>
            {/* <a href="/painel"> */}
            {/* <img src={logo} alt="Logo" width={150} /> */}
            <h3 style={{ color: "#fff", paddingLeft: 15 }}>{empresanome}</h3>
            {/* </a> */}
          </div>
          {/* Header Logo End */}
          {/* Header Action Start */}
          <div className="login-header-action action-2 ml-auto">
            {/* <a className="action author" href="#">
                <img src="assets/images/author/author-15.jpg" alt="Author" />
              </a> */}
            {/* <div className="dropdown">
                <button className="action more" data-bs-toggle="dropdown">
                  <span />
                  <span />
                  <span />
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <a className href="#">
                      <i className="icofont-user" /> Edit Perfil
                    </a>
                  </li>
                  <li>
                    <a className href="/">
                      <i className="icofont-logout" /> Sair
                    </a>
                  </li>
                </ul>
              </div> */}
          </div>
          {/* Header Action End */}
        </div>
        {/* Login Header Wrapper End */}
      </div>
      {/* Login Header End */}
      {/* Courses Enroll Start */}
      <div className="section">
        {/* Courses Enroll Wrapper Start */}
        <div className="courses-enroll-wrapper">
          {/* Courses Video Player Start */}
          <div className="courses-video-player">
            {/* Courses Video Container Start */}
            {/* <div className="vidcontainer"> */}

            { todosVideosConcluidos ? (
              <div className="conclusao-treinamento" style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '400px',
                padding: '2rem',
                textAlign: 'center',
                backgroundColor: '#eefbf3',
                borderRadius: '16px',
                border: '1px solid #d4edda'
              }}>
                <div style={{ fontSize: '64px', marginBottom: '1rem' }}>🎉</div>
                <h3 style={{ color: '#155724', marginBottom: '0.5rem' }}>Parabéns!</h3>
                <p style={{ color: '#155724', marginBottom: '1.5rem', fontSize: '1.1rem' }}>
                  Você concluiu todos os vídeos deste treinamento.
                </p>
                <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
                  {produto[0]?.progresso === 100 && produto[0]?.status === 0 && (
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => history.push("/avaliacao/" + produto[0]._id)}
                    >
                      Ir para Avaliação
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => history.push("/painel")}
                  >
                    Voltar ao Painel
                  </button>
                </div>
              </div>
            ) : (!todosVideosConcluidos && video.length > 15 && !videoUrl) || carregandoVideo ? (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '400px',
                padding: '2rem',
                textAlign: 'center',
                backgroundColor: '#eefbf3',
                borderRadius: '16px',
                border: '1px solid #d4edda'
              }}>
                <div style={{ color: '#155724', fontSize: '1.05rem' }}>
                  Carregando próximo tópico...
                </div>
              </div>
            ) : video.length > 15 && videoUrl ? (
              <video ref={playerRef} controls playsInline onEnded={onVideoEnd}>
                <source src={videoUrl} type="video/mp4" />
              </video>
            ) : null
            }
            { !todosVideosConcluidos && video.length <= 15 && video.length > 0 &&
              <div style={{
                position: 'relative',
                width: '100%',
                aspectRatio: '16 / 9',
                maxHeight: '70vh',
                background: '#000',
                borderRadius: '16px',
                overflow: 'hidden'
              }}>
                {!videoStarted ? (
                  // Mostrar imagem de preview antes do vídeo começar
                  <div 
                    className="youtube-preview-container"
                    onClick={handleStartVideo}
                    style={{
                      position: 'relative',
                      width: '100%',
                      height: '100%',
                      cursor: 'pointer',
                      background: 'transparent'
                    }}
                  >
                    <img
                      src={getYouTubeThumbnail(video)}
                      alt={currentTitle || 'Preview do vídeo'}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block'
                      }}
                      onError={(e) => {
                        // Se maxresdefault não existir, tenta hqdefault
                        if (e.target.src.includes('maxresdefault')) {
                          e.target.src = `https://img.youtube.com/vi/${video}/hqdefault.jpg`;
                        }
                      }}
                    />
                    {/* Botão de play customizado */}
                    <div 
                      className="custom-play-button"
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '80px',
                        height: '80px',
                        backgroundColor: 'rgba(79, 70, 229, 0.9)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 20px rgba(79, 70, 229, 0.4)',
                        zIndex: 10
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1.1)';
                        e.currentTarget.style.backgroundColor = 'rgba(79, 70, 229, 1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1)';
                        e.currentTarget.style.backgroundColor = 'rgba(79, 70, 229, 0.9)';
                      }}
                    >
                      <svg 
                        width="32" 
                        height="32" 
                        viewBox="0 0 24 24" 
                        fill="white"
                        style={{ marginLeft: '4px' }}
                      >
                        <path d="M8 5v14l11-7z"/>
                      </svg>
                    </div>
                  </div>
                ) : (
                  // Mostrar player do YouTube quando vídeo for iniciado
                  <YouTube
                    videoId={video}
                    opts={opts}
                    onEnd={onVideoEnd}
                    onReady={() => {}}
                    onPlay={() => {}}
                    onStateChange={() => {}}
                    className={"vidcontainer"}
                  />
                )}
                {/* Overlay adicional para bloquear cliques no logo do YouTube (apenas quando vídeo estiver tocando) */}
                {videoStarted && (
                  <div 
                    className="youtube-logo-blocker"
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    width: '160px',
                    height: '70px',
                    zIndex: 1000,
                    cursor: 'not-allowed',
                    pointerEvents: 'auto',
                    background: 'transparent'
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                  }}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                  }}
                  onMouseUp={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                  }}
                    title="Acesso restrito - Use apenas através desta plataforma"
                  />
                )}
                {/* Overlay para bloquear botão "Watch on YouTube" - cobre toda a parte inferior (apenas quando vídeo estiver tocando) */}
                {videoStarted && !isMaster && (
                  <div 
                    className="youtube-watch-blocker"
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: '100px',
                    zIndex: 10000,
                    cursor: 'default',
                    pointerEvents: 'auto',
                    background: 'transparent',
                    userSelect: 'none',
                    WebkitUserSelect: 'none'
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                  }}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                  }}
                  onMouseUp={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                  }}
                  onMouseMove={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                  }}
                  onTouchStart={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                  }}
                  onTouchEnd={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                  }}
                    title="Acesso restrito - Use apenas através desta plataforma"
                  />
                )}
              </div>
            }

          </div>
          {/* Courses Video Container End */}

          {/* </div> */}
          {/* Courses Video Player End */}
          {/* Courses Video Playlist Start */}
          <div className="courses-video-playlist">
            <div className="playlist-title">
              <h3 className="title">{produto[0]?.titulo}</h3>
            </div>
            {/* Video Playlist Start  */}
            <div className="video-playlist">
              <div className="video-playlist-topics">
              <div className="accordion" id="videoPlaylist">
                {Array.isArray(etapas) &&
                  etapas.map((itemParent, index) => (
                    <div className="accordion-item" key={index}>
                      <button
                        className="collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${index}`}
                        aria-expanded="false"
                        aria-controls={`collapse-${index}`}
                      >
                        <p key={index}>
                          <i className="fa fa-folder-open" style={{ marginRight: '10px', fontSize: '16px' }}></i>
                          {itemParent.titulo}
                        </p>
                      </button>
                      <div
                        id={`collapse-${index}`}
                        className="accordion-collapse collapse"
                        data-bs-parent="#videoPlaylist"
                      >
                        {(Array.isArray(itemParent?.subtopicos) ? itemParent.subtopicos : []).map((item, index) => (
                          <nav className="vids" style={item.status == 1 ? { backgroundColor: '#a6d9aa' } : item._id == currentSubTopic ? { borderWidth: 2, borderStyle: 'solid' } : {}}>
                            <a
                              className="link active"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setCurrentValues(
                                  item.linkVideo,
                                  itemParent._id,
                                  item._id,
                                  item.titulo
                                );
                              }}
                            >
                              <p>{item.titulo}&nbsp;&nbsp;
                                {item.status == 1 &&
                                  <i className="fa fa-check" style={{ color: 'green', fontSize: 18 }}></i>
                                }
                              </p>
                              <span className="total-duration">
                                {item.minutosVideo} minutos
                              </span>
                            </a>
                          </nav>
                        ))}
                      </div>
                    </div>
                  ))}
                {produto[0]?.status == 0 &&
                  <div className="accordion-item">
                    <button
                      className="collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-avaliacao"
                      aria-expanded="false"
                      aria-controls="collapse-avaliacao"
                      style={produto[0]?.progresso == 100 ? {} : { backgroundColor: "#d3d3d3" }}
                      data-category="avaliacao"
                    >
                      <p><i className="fa fa-clipboard-check" style={{ marginRight: '10px', fontSize: '16px' }}></i>Avaliação</p>
                    </button>
                    <div
                      id="collapse-avaliacao"
                      className="accordion-collapse collapse"
                      data-bs-parent="#videoPlaylist"
                    >

                      <nav className="vids">
                        <a
                          className="link active"
                          style={produto[0]?.progresso == 100 ? { cursor: "pointer" } : { cursor: "pointer", backgroundColor: "#d3d3d3", color: "gray" }}
                          onClick={() => gotoAvaliacao()}
                        >
                          <p>Realizar Avaliação&nbsp;&nbsp;
                          </p>
                          <span className="total-duration">
                            Bloqueado
                          </span>
                        </a>
                      </nav>

                    </div>
                  </div>
                }
              </div>
              </div>
              <div className="video-playlist-footer">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => history.push("/painel")}
                >
                  Voltar
                </button>

                {buildMateriaisApoio(produto[0]).length > 0 ? (
                  <button
                    type="button"
                    className="btn btn-info"
                    style={{ marginLeft: 8 }}
                    onClick={() => setMaterialModalOpen(true)}
                  >
                    Baixar Material de Apoio
                  </button>
                ) : null}
              </div>
            </div>
            {/* Video Playlist End  */}
          </div>
          {/* Courses Video Playlist End */}
        </div>
        {/* Courses Enroll Wrapper End */}
      </div>
      {/* Courses Enroll End */}

      {materialModalOpen &&
        createPortal(
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 100050,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 16,
            }}
            onClick={() => setMaterialModalOpen(false)}
            role="presentation"
          >
            <div
              style={{
                background: "#fff",
                borderRadius: 8,
                maxWidth: 520,
                width: "100%",
                maxHeight: "90vh",
                overflow: "auto",
                boxShadow: "0 12px 48px rgba(0, 0, 0, 0.3)",
              }}
              onClick={(e) => e.stopPropagation()}
              role="dialog"
              aria-modal="true"
              aria-labelledby="modalMaterialApoioTitulo"
            >
              <div
                style={{
                  padding: "14px 18px",
                  borderBottom: "1px solid #e5e7eb",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h4
                  style={{ margin: 0, fontSize: 18, fontWeight: 600 }}
                  id="modalMaterialApoioTitulo"
                >
                  Material de apoio
                </h4>
                <button
                  type="button"
                  className="close"
                  aria-label="Fechar"
                  onClick={() => setMaterialModalOpen(false)}
                  style={{
                    fontSize: 28,
                    lineHeight: 1,
                    opacity: 0.55,
                    border: "none",
                    background: "none",
                    padding: "0 4px",
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div style={{ padding: 18 }}>
                <p className="text-muted" style={{ marginBottom: 14, fontSize: 13 }}>
                  Selecione um arquivo para baixar ou abrir em nova aba.
                </p>
                <ul className="list-group" style={{ marginBottom: 0 }}>
                  {buildMateriaisApoio(produto[0]).map((item, i) => (
                    <li
                      key={`${item.url}-${i}`}
                      className="list-group-item"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 10,
                      }}
                    >
                      <span style={{ wordBreak: "break-word", flex: "1 1 200px" }}>
                        {item.nome}
                      </span>
                      <a
                        href={item.url}
                        className="btn btn-sm btn-primary"
                        style={{ flexShrink: 0 }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Download
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div
                style={{
                  padding: "12px 18px",
                  borderTop: "1px solid #e5e7eb",
                  textAlign: "right",
                }}
              >
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => setMaterialModalOpen(false)}
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
}
